import React from 'react';
import { connect } from 'react-redux';
import { JWTProvider, PPMSSnippet } from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';

export class PPMSSnippetPanel extends React.Component<any> {
  render() {
    const { jwt, session } = this.props;

    if (!jwt) return null;

    return (
      <JWTProvider jwt={jwt} refreshJWT={session.refreshJWT}>
        <PPMSSnippet />
      </JWTProvider>
    );
  }
}

const mapStateToProps = state => ({
  jwt: state.session.jwt,
});

export default withInject({
  session: 'AuthCrate.session',
})(connect(mapStateToProps, null)(PPMSSnippetPanel));
